import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';

function ReportPage() {
  const { personName } = useParams();
  const location = useLocation();
  const [dateTimes, setDateTimes] = useState([]);

  const query = new URLSearchParams(location.search);
  const fromDate = query.get('fromDate');
  const toDate = query.get('toDate');

  useEffect(() => {
    if (fromDate && toDate) {
      fetchData();
    }
  }, [fromDate, toDate]);

  const fetchData = () => {
    fetch('/DetailReadAPI', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        TABLE: 'RosaF',
        FIELD: 'InDateTime, OutDateTime',
        WHERE: `PersonName='${personName}' AND InDateTime >= '${fromDate}' AND OutDateTime <= '${toDate}'`,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && data.length > 0) {
          setDateTimes(data);
        } else {
          setDateTimes([]);
        }
      })
      .catch((error) => console.error('Error fetching date times:', error));
  };

  return (
    <div
      style={{
        background: 'linear-gradient(to bottom, #fff7ad, #ffa9f9)',
        minHeight: '100vh',
        padding: '20px',
        textAlign: 'center',
      }}
    >
      <h2 style={{ color: '#E11584' }}>Details of {personName}</h2>
      {dateTimes.length > 0 ? (
        <table
          border="2"
          cellPadding="5"
          style={{
            margin: '0 auto',
            borderCollapse: 'collapse',
            backgroundColor: '#FFD1DC',
            borderColor: '#E11584',
            width: '50%',
          }}
        >
          <tbody>
            <tr>
              <td style={{ textAlign: 'center', padding: '10px', color: '#E11584' }}>ClockIn Time</td>
              <td style={{ textAlign: 'center', padding: '10px' }}>
                {dateTimes.map((record, index) => (
                  <div key={`in-${index}`} style={{ marginBottom: '5px' }}>
                    {record.InDateTime || 'N/A'}
                  </div>
                ))}
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: 'center', padding: '10px', color: '#E11584' }}>ClockOut Time</td>
              <td style={{ textAlign: 'center', padding: '10px' }}>
                {dateTimes.map((record, index) => (
                  <div key={`out-${index}`} style={{ marginBottom: '5px' }}>
                    {record.OutDateTime || 'N/A'}
                  </div>
                ))}
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: 'center', padding: '10px', color: '#E11584' }}>Duration</td>
              <td style={{ textAlign: 'center', padding: '10px' }}>
                {dateTimes.map((record, index) => {
                  const duration = calculateDuration(record.InDateTime, record.OutDateTime);
                  return (
                    <div key={`duration-${index}`} style={{ marginBottom: '5px' }}>
                      {duration}
                    </div>
                  );
                })}
              </td>
            </tr>
          </tbody>
        </table>
      ) : (
        <p>No data available for the selected date range.</p>
      )}
    </div>
  );
}

const calculateDuration = (inTime, outTime) => {
  if (!inTime || !outTime) return 'N/A';
  const inDate = new Date(inTime);
  const outDate = new Date(outTime);
  const duration = outDate - inDate;

  const hours = Math.floor(duration / (1000 * 60 * 60));
  const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));
  return `${hours}h ${minutes}m`;
};

export default ReportPage;
